import { createAction, props } from '@ngrx/store';
import { LoggedInUser, UserActionTypes } from './users.models';

export const loading = createAction(UserActionTypes.LOADING);
export const loadingDone = createAction(UserActionTypes.LOADING_DONE);
export const loadLoggedInUser = createAction(UserActionTypes.LOAD_LOGGED_IN_USER);
export const loadedLoggedInUser = createAction(UserActionTypes.LOADED_LOGGED_IN_USER, props<{ data: any }>());
export const updateUserLanguage = createAction(UserActionTypes.UPDATE_USER_LANG, props<{ user: LoggedInUser }>());
export const updatedLoggedInUser = createAction(UserActionTypes.UPDATED_LOGGED_IN_USER, props<{ user: LoggedInUser }>());
